var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ca-interventions"},[_c('h3',{staticClass:"title title-page text-primary font-medium"},[_vm._v("Audits et Bilans")]),_c('list-interventions-table',{attrs:{"is-audit":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }